import React from 'react';
import PropTypes from 'prop-types';
import { MppHeaderComponent, MppFooterComponent } from '../../home/components/MppHeaderFooter';

// Containers
import SessionHandler from '../containers/SessionHandler';
import HeroModuleSession from '../containers/HeroModule';

/**
 * Help Template to show hero module and handle SessionHandler
 * @param {Object} props   the children component for for channelsteering page
 */
const HelpTemplate = (props) => (
  <div>
    <MppHeaderComponent />
    <div className="vx_mainContent" role="main">
      <SessionHandler />
      <HeroModuleSession />
      { props.children }
    </div>
    <MppFooterComponent />
  </div>
);

// Property Types
HelpTemplate.propTypes = {
  children: PropTypes.element.isRequired,
};

export default HelpTemplate;
